import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Controller, useForm } from 'react-hook-form'
import SydModal from '../../../../commonDesign/SydModal'
import SydModalActions from '../../../../commonDesign/SydModal/SydModalActions'
import SydButton from '../../../../commonDesign/Button'
import SydInput from '../../../../commonDesign/SydInput'
import SydLabel from '../../../../commonDesign/SydLabel'

function NewVersionModal ({ open, onClose, onConfirm, isProcessing }) {
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      description: ''
    }
  })

  useEffect(() => {
    if (!open) {
      reset({ description: '' })
    }
  }, [open, reset])

  const handleConfirm = useCallback(async ({ description }) => {
    await onConfirm({ description: description || null })
  }, [onConfirm])

  const handleClose = useCallback(() => {
    reset({ description: '' })
    onClose()
  }, [reset, onClose])

  return (
    <SydModal
      open={open}
      onClose={handleClose}
      title='Create New Version'
      subtitle='A new version will be created from the current editor content.'
      size='small'
    >
      <form onSubmit={handleSubmit(handleConfirm)}>
        <div className='flex flex-col gap-3 mb-4'>
          <Controller
            name='description'
            control={control}
            render={({ field }) => (
              <SydLabel label='Description (optional)'>
                <SydInput
                  placeholder='Describe this version...'
                  size='sm'
                  {...field}
                />
              </SydLabel>
            )}
          />
        </div>
        <SydModalActions>
          <SydButton
            variant='secondary'
            type='button'
            onClick={handleClose}
            disabled={isProcessing}
          >
            Cancel
          </SydButton>
          <SydButton
            variant='primary'
            type='submit'
            processing={isProcessing}
            disabled={isProcessing}
          >
            Create Version
          </SydButton>
        </SydModalActions>
      </form>
    </SydModal>
  )
}

NewVersionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool
}

export default NewVersionModal
